import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import {
    BarChart, Bar, ResponsiveContainer, Tooltip, XAxis, YAxis, CartesianGrid,
    PieChart, Pie, Cell, Legend,
} from "recharts";

const STATUS_COLORS = {
    awaiting: "#F59E0B",
    in_progress: "#3B82F6",
    answered: "#6366F1",
    closed: "#94A3B8",
};

const STATUS_LABELS = {
    awaiting: "Ожидают",
    in_progress: "В работе",
    answered: "Отвечено",
    closed: "Закрыто",
};

export default function Analytics() {
    const [data, setData] = useState(null);

    useEffect(() => {
        api.get("/analytics/charts").then((r) => setData(r.data));
    }, []);

    return (
        <div className="p-4 lg:p-10" data-testid="analytics-page">
            <header className="mb-6 lg:mb-8">
                <div className="text-xs uppercase tracking-[0.15em] text-slate-500 mb-1 lg:mb-2 hidden lg:block">Отчёты</div>
                <h1 className="text-2xl lg:text-4xl font-heading font-medium tracking-tight text-slate-900">
                    Аналитика
                </h1>
                <p className="text-slate-500 mt-1 lg:mt-2 text-sm lg:text-base">Подробные показатели за последние 30 дней</p>
            </header>

            <div className="grid grid-cols-1 lg:grid-cols-3 gap-3 lg:gap-5">
                <div className="lg:col-span-2 bg-white border border-slate-200 rounded-lg p-6">
                    <h3 className="font-heading font-medium text-slate-900 mb-1">Обращения по дням</h3>
                    <p className="text-sm text-slate-500 mb-6">Количество новых обращений за каждый день</p>
                    <div className="h-72" data-testid="analytics-daily-chart">
                        {data?.daily?.length > 0 && (
                            <ResponsiveContainer width="100%" height="100%">
                                <BarChart data={data.daily}>
                                    <CartesianGrid stroke="#F1F5F9" vertical={false} />
                                    <XAxis dataKey="date" tick={{ fill: "#94A3B8", fontSize: 11 }} axisLine={false} tickLine={false} />
                                    <YAxis tick={{ fill: "#94A3B8", fontSize: 12 }} axisLine={false} tickLine={false} allowDecimals={false} />
                                    <Tooltip contentStyle={{ border: "1px solid #E2E8F0", borderRadius: 8, fontSize: 12 }} />
                                    <Bar dataKey="count" fill="#1E3A8A" radius={[4, 4, 0, 0]} />
                                </BarChart>
                            </ResponsiveContainer>
                        )}
                    </div>
                </div>

                <div className="bg-white border border-slate-200 rounded-lg p-6">
                    <h3 className="font-heading font-medium text-slate-900 mb-1">По статусам</h3>
                    <p className="text-sm text-slate-500 mb-6">Распределение обращений</p>
                    <div className="h-72" data-testid="analytics-status-chart">
                        {data?.by_status?.length > 0 ? (
                            <ResponsiveContainer width="100%" height="100%">
                                <PieChart>
                                    <Pie
                                        data={data.by_status.map((s) => ({ ...s, name: STATUS_LABELS[s.status] || s.status }))}
                                        dataKey="count"
                                        nameKey="name"
                                        innerRadius={60}
                                        outerRadius={90}
                                        paddingAngle={2}
                                    >
                                        {data.by_status.map((s, i) => (
                                            <Cell key={i} fill={STATUS_COLORS[s.status] || "#94A3B8"} />
                                        ))}
                                    </Pie>
                                    <Tooltip contentStyle={{ border: "1px solid #E2E8F0", borderRadius: 8, fontSize: 12 }} />
                                    <Legend wrapperStyle={{ fontSize: 12 }} />
                                </PieChart>
                            </ResponsiveContainer>
                        ) : (
                            <div className="h-full flex items-center justify-center text-sm text-slate-400">
                                Нет данных
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}
